import get from "lodash/get";
import createRestApiClient from "../../utility/createRestApiClient";

import {
  CLEAR_RERUN_TEST_HISTORY,
  CLEAR_RERUN_TEST_DETAILS,
  DEBUGGER_STATE_FAILED,
  DEBUGGER_STATE_LOADING,
  DEBUGGER_STATE_SUCCESS,
  FETCH_ACTIVE_TUNNEL_LIST_FAILED,
  FETCH_ACTIVE_TUNNEL_LIST_LOADING,
  FETCH_ACTIVE_TUNNEL_LIST_SUCCESS,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS,
  FETCH_SIMILAR_TEST_RETRY_LIST_FAILED,
  FETCH_SIMILAR_TEST_RETRY_LIST_LOADING,
  FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS,
  FETCH_TEST_REPRODUCE_HISTORY_FAILED,
  FETCH_TEST_REPRODUCE_HISTORY_LOADING,
  FETCH_TEST_REPRODUCE_HISTORY_SUCCESS,
  FETCH_TEST_RETRY_HISTORY_FAILED,
  FETCH_TEST_RETRY_HISTORY_LOADING,
  FETCH_TEST_RETRY_HISTORY_SUCCESS,
  LAMBDATEST_PARENT_TEST_DETAIL_LOADING,
  LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS,
  LAMBDATEST_PARENT_TEST_DETAIL_FAILED,
  MODIFY_BREAKPOINT_FAILED,
  MODIFY_BREAKPOINT_LOADING,
  MODIFY_BREAKPOINT_SUCCESS,
  PAUSE_REPLAY_TEST_FAILED,
  PAUSE_REPLAY_TEST_LOADING,
  PAUSE_REPLAY_TEST_SUCCESS,
  RERUN_TEST_FAILED,
  RERUN_TEST_LOADING,
  RERUN_TEST_SUCCESS,
  RESUME_REPLAY_TEST_LOADING,
  RESUME_REPLAY_TEST_SUCCESS,
  RESUME_REPLAY_TEST_FAILED,
  RESET_ACTIVE_TUNNEL_LIST,
  RESET_SIMILAR_TEST_LIST,
  SET_RERUN_TYPE,
  SET_RERUN_FULLSCREEN_MODE,
  SET_IS_RERUN_PAGE,
  SET_IS_RERUN_EDIT_CAPABILITY_MODE,
  SET_IS_RERUN_ADVANCED_SETTINGS_MODE,
  STEPOVER_REPLAY_TEST_FAILED,
  STEPOVER_REPLAY_TEST_LOADING,
  STEPOVER_REPLAY_TEST_SUCCESS,
  STOP_REPLAY_TEST_LOADING,
  STOP_REPLAY_TEST_SUCCESS,
  STOP_REPLAY_TEST_FAILED,
  UPDATE_SELECTED_TEST_TO_RETRY,
  UPDATE_SELECTED_TEST_TO_REPRODUCE,
  UPDATE_TEST_ATTEMPTS,
  UPDATE_TEST_DETAILS_FAILED,
  UPDATE_TEST_DETAILS_LOADING,
  UPDATE_TEST_DETAILS_SUCCESS,
  UPDATE_PLAYBACK_SPEED_LOADING,
  UPDATE_PLAYBACK_SPEED_SUCCESS,
  UPDATE_PLAYBACK_SPEED_FAILED,
  UPDATE_COMMAND_BREAKPOINT,
  UPDATE_UNSAVED_CAPABILITY,
  SET_RERUN_TEST_DETAILS,
  FETCH_ALL_BREAKPOINTS_LOADING,
  FETCH_ALL_BREAKPOINTS_SUCCESS,
  FETCH_ALL_BREAKPOINTS_FAILED,
  UPDATE_DEBUGGER_STATE
} from "../actionTypeConstants/rerunTestConstants";

import { RerunTypeMap } from "../../utility/ml2.0/constants";
import { getApiBaseUrl } from "../../utility/utilityFunctions";
import { getCookieData } from "../../utility/cookieHandler/handler";

const SIMILAR_TEST_COUNT = 10;

export const fetchActiveTunnelList = () => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    FETCH_ACTIVE_TUNNEL_LIST_LOADING,
    FETCH_ACTIVE_TUNNEL_LIST_SUCCESS,
    FETCH_ACTIVE_TUNNEL_LIST_FAILED
  ];

  const endPoint = `${getApiBaseUrl('https', null, true)}/automation/api/v1/tunnels`;

  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);

  let headers = {
    Authorization: `Bearer ` + access_token,
    Accept: "application/json"
  };

  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: headers
      })
  };
};

export const fetchSimilarTestList = (
  userInfo,
  testName,
  debugType,
  debuggerTestId
) => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    FETCH_SIMILAR_TEST_RETRY_LIST_LOADING,
    FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS,
    FETCH_SIMILAR_TEST_RETRY_LIST_FAILED
  ];

  if (debugType === RerunTypeMap.REPRODUCE) {
    types = [
      FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING,
      FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS,
      FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED
    ];
  }
  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const searchTextQuery = testName ? `&testName=${testName}` : "";

  const endPoint = `${getApiBaseUrl()}/api/v2/test?timezone=null&offset=0&limit=${SIMILAR_TEST_COUNT}&includeCreated=0&caps=1${searchTextQuery}&sortBy=newest&debugType=${debugType}&debuggerTestId=${debuggerTestId}`;

  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: headers
      })
  };
};

export const fetchTestRetryHistory = (userInfo, parentTestId, debugType) => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    FETCH_TEST_RETRY_HISTORY_LOADING,
    FETCH_TEST_RETRY_HISTORY_SUCCESS,
    FETCH_TEST_RETRY_HISTORY_FAILED
  ];

  if (debugType === RerunTypeMap.REPRODUCE) {
    types = [
      FETCH_TEST_REPRODUCE_HISTORY_LOADING,
      FETCH_TEST_REPRODUCE_HISTORY_SUCCESS,
      FETCH_TEST_REPRODUCE_HISTORY_FAILED
    ];
  }

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/api/v2/test?timezone=null&offset=0&limit=${SIMILAR_TEST_COUNT}&includeCreated=0&caps=1&sortBy=newest&parentTestId=${parentTestId}&debugType=${debugType}`;

  return {
    types: types,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: headers
      })
  };
};

export const updateTestDetails = (userInfo, sessionId, data) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    UPDATE_TEST_DETAILS_LOADING,
    UPDATE_TEST_DETAILS_SUCCESS,
    UPDATE_TEST_DETAILS_FAILED
  ];

  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);

  let headers = {
    Authorization: `Bearer ` + access_token,
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl('https', null, true)}/automation/api/v1/sessions/${sessionId}`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(`${endPoint}`, data, {
          headers: headers
        })
        .then(response => {
          if (data) {
            addToast({
              message:
                response?.data?.message || "Test details updated successfully",
              variant: toastVariants.SUCCESS,
              extendDuration
            });
          }
          return response;
        })
        .catch(error => {
          if (data) {
            addToast({
              message:
                error?.response?.data?.message ||
                "Failed to mark status, please try again",
              variant: toastVariants.DANGER,
              extendDuration
            });
          }
          return error;
        })
  };
};

export const rerunTest = (userInfo, data) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [RERUN_TEST_LOADING, RERUN_TEST_SUCCESS, RERUN_TEST_FAILED];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/run`;

  return {
    types: types,
    promise: () =>
      apiClient
        .post(`${endPoint}`, data, {
          headers: headers
        })
        .catch(error => {
          if (data) {
            addToast({
              message:
                error?.response?.data?.message ||
                "Failed to rerun test, please try again",
              variant: toastVariants.DANGER,
              extendDuration
            });
          }
          return error;
        })
  };
};

export const fetchParentTestDetailHash = (automationApiHost, testId) => {
  if (!testId) {
    return false;
  }
  let header = {};
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;

  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);

  header = {
    Authorization: `Bearer ` + access_token,
    Accept: "application/json"
  };

  let types = [
    LAMBDATEST_PARENT_TEST_DETAIL_LOADING,
    LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS,
    LAMBDATEST_PARENT_TEST_DETAIL_FAILED
  ];

  let testPathURL = `/api/v1/test/${testId}`;

  return {
    types: types,
    promise: () =>
      mockApiClient.get(testPathURL, {
        headers: header
      })
  };
};

export const stopReplayTest = (userInfo, sessionId) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    STOP_REPLAY_TEST_LOADING,
    STOP_REPLAY_TEST_SUCCESS,
    STOP_REPLAY_TEST_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/stop`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(
          `${endPoint}`,
          {},
          {
            headers: headers
          }
        )
        .then(response => {
          addToast({
            message: response?.data?.message || "Test stopped successfully",
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to stop test, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const pauseReplayTest = (userInfo, sessionId) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    PAUSE_REPLAY_TEST_LOADING,
    PAUSE_REPLAY_TEST_SUCCESS,
    PAUSE_REPLAY_TEST_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/pause`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(
          `${endPoint}`,
          {},
          {
            headers: headers
          }
        )
        .then(response => {
          addToast({
            message: response?.data?.message || "Test paused successfully",
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to pause test, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const resumeReplayTest = (userInfo, sessionId, commandRequestId) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    RESUME_REPLAY_TEST_LOADING,
    RESUME_REPLAY_TEST_SUCCESS,
    RESUME_REPLAY_TEST_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/resume`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(
          `${endPoint}`,
          {
            commandRequestId: commandRequestId
          },
          {
            headers: headers
          }
        )
        .then(response => {
          addToast({
            message: response?.data?.message || "Test resumed successfully",
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to resume test, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const stepoverReplayTest = (userInfo, sessionId, commandRequestId) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    STEPOVER_REPLAY_TEST_LOADING,
    STEPOVER_REPLAY_TEST_SUCCESS,
    STEPOVER_REPLAY_TEST_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/stepover`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(
          `${endPoint}`,
          {
            commandRequestId: commandRequestId
          },
          {
            headers: headers
          }
        )
        .then(response => {
          addToast({
            message: response?.data?.message || "Test stepover successful",
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to stepover command, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const getDebuggerState = (userInfo, sessionId) => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    DEBUGGER_STATE_LOADING,
    DEBUGGER_STATE_SUCCESS,
    DEBUGGER_STATE_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/debugger-state`;

  return {
    types: types,
    promise: () =>
      apiClient
        .get(`${endPoint}`, {
          headers: headers
        })
        .then(response => {
          return response;
        })
        .catch(error => {
          return error;
        })
  };
};

export const modifyBreakpoint = (
  userInfo,
  sessionId,
  commandRequestId,
  action = "add"
) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    MODIFY_BREAKPOINT_LOADING,
    MODIFY_BREAKPOINT_SUCCESS,
    MODIFY_BREAKPOINT_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/breakpoint`;

  const data = {
    commandRequestId: commandRequestId,
    action: action // 'add' or 'remove'
  };

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(`${endPoint}`, data, {
          headers: headers
        })
        .then(response => {
          addToast({
            message: `Breakpoint ${
              action === "add" ? "Added" : "Removed"
            } successfully`,
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to modify breakpoint, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const fetchAllBreakpoints = (userInfo, sessionId) => {
  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    FETCH_ALL_BREAKPOINTS_LOADING,
    FETCH_ALL_BREAKPOINTS_SUCCESS,
    FETCH_ALL_BREAKPOINTS_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/breakpoint`;

  return {
    types: types,
    promise: () =>
      apiClient
        .get(`${endPoint}`, {
          headers: headers
        })
        .then(response => {
          return response;
        })
        .catch(error => {
          return error;
        })
  };
};

export const updatePlaybackSpeed = (userInfo, sessionId, playbackSpeed) => {
  const { addToast = () => {}, extendDuration = false, toastVariants = {} } =
    window.toast || {};

  const baseURL = getApiBaseUrl();

  const apiClient = createRestApiClient().withConfig({
    baseURL: baseURL
  }).client;

  let types = [
    UPDATE_PLAYBACK_SPEED_LOADING,
    UPDATE_PLAYBACK_SPEED_SUCCESS,
    UPDATE_PLAYBACK_SPEED_FAILED
  ];

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  let headers = {
    Authorization: `Basic ` + btoa(username + ":" + accessKey),
    Accept: "application/json"
  };

  const endPoint = `${getApiBaseUrl()}/replay/v1/session/${sessionId}/speed`;

  return {
    types: types,
    promise: () =>
      apiClient
        .patch(
          `${endPoint}`,
          { speed: playbackSpeed },
          {
            headers: headers
          }
        )
        .then(response => {
          addToast({
            message:
              response?.data?.message || "Playback speed updated successfully",
            variant: toastVariants.SUCCESS,
            extendDuration
          });

          return response;
        })
        .catch(error => {
          addToast({
            message:
              error?.response?.data?.message ||
              "Failed to update playback speed, please try again",
            variant: toastVariants.DANGER,
            extendDuration
          });

          return error;
        })
  };
};

export const updateTestAttempts = data => {
  return dispatch =>
    dispatch({
      type: UPDATE_TEST_ATTEMPTS,
      payload: data
    });
};

export const updateSelectedTestToRerun = (data, debugType) => {
  return dispatch =>
    dispatch({
      type:
        debugType === RerunTypeMap.REPLAY
          ? UPDATE_SELECTED_TEST_TO_RETRY
          : UPDATE_SELECTED_TEST_TO_REPRODUCE,
      payload: data
    });
};

export const resetActiveTunnelList = () => {
  return dispatch =>
    dispatch({
      type: RESET_ACTIVE_TUNNEL_LIST
    });
};

export const resetSimilarTestList = () => {
  return dispatch =>
    dispatch({
      type: RESET_SIMILAR_TEST_LIST
    });
};

export const clearRerunTestHistory = () => {
  return dispatch =>
    dispatch({
      type: CLEAR_RERUN_TEST_HISTORY
    });
};

export const setRerunType = rerunType => {
  return dispatch =>
    dispatch({
      type: SET_RERUN_TYPE,
      payload: rerunType
    });
};

export const setIsRerunPage = isRerunPage => {
  return dispatch =>
    dispatch({
      type: SET_IS_RERUN_PAGE,
      payload: isRerunPage
    });
};

export const setRerunCapabilityMode = rerunCapabilityMode => {
  return dispatch =>
    dispatch({
      type: SET_IS_RERUN_EDIT_CAPABILITY_MODE,
      payload: rerunCapabilityMode
    });
};

export const setRerunAdvancedSettingsMode = advancedSettingsMode => {
  return dispatch =>
    dispatch({
      type: SET_IS_RERUN_ADVANCED_SETTINGS_MODE,
      payload: advancedSettingsMode
    });
};

export const setRerunFullScreenMode = fullScreenMode => {
  return dispatch =>
    dispatch({
      type: SET_RERUN_FULLSCREEN_MODE,
      payload: fullScreenMode
    });
};

export const setRerunTestDetails = (key, value) => {
  return dispatch =>
    dispatch({
      type: SET_RERUN_TEST_DETAILS,
      payload: { key, value }
    });
};

export const clearRerunTestDetails = () => {
  return dispatch =>
    dispatch({
      type: CLEAR_RERUN_TEST_DETAILS
    });
};

export const updateDebuggerState = data => {
  return dispatch =>
    dispatch({
      type: UPDATE_DEBUGGER_STATE,
      payload: data
    });
};

export const updateCommandBreakpoint = data => {
  return dispatch =>
    dispatch({
      type: UPDATE_COMMAND_BREAKPOINT,
      payload: data
    });
};

export const updateUnsavedCapability = data => {
  return dispatch =>
    dispatch({
      type: UPDATE_UNSAVED_CAPABILITY,
      payload: data
    });
}
